import React from 'react';
import editIcon from "../../../../common/images/editIcon.png";

const getFuelRateColumns = (handleEditBunk, enblAct = false) => {

  const columns = [
    {
      key: 'name',
      label: 'AGENCY DETAILS',
      render: (row) => {
        const district = row.district ?? '';
        const state = row.state ?? '';
        return (
          <>
            <span className='agency-name-txt'>{row.name}</span>
            <div className='agency-address1-txt'>{district}, {state}</div>
          </>
        );
      },
    },
    {
      key: 'petrol',
      label: 'Petrol',
      render: (row) => {
        const petrolVal = row?.fuelRate?.petrol ? '₹ ' + row?.fuelRate?.petrol : '';
        return <div className='fual-amount-val'>{petrolVal}</div>;
      },
    },
    {
      key: 'diesel',
      label: 'Diesel',
      render: (row) => {
        const dieselVal = row?.fuelRate?.diesel ? '₹ ' + row?.fuelRate?.diesel : '';
        return <div className='fual-amount-val'>{dieselVal}</div>;
      },
    },
    {
      key: 'lpg',
      label: 'LPG',
      render: (row) => {
        const lpgVal = row?.fuelRate?.lpg ? '₹ ' + row?.fuelRate?.lpg : '';
        return <div className='fual-amount-val'>{lpgVal}</div>;
      },
    },
    {
      key: 'cng',
      label: 'CNG',
      render: (row) => {
        const cngVal = row?.fuelRate?.cng ? '₹ ' + row?.fuelRate?.cng : '';
        return <div className='fual-amount-val'>{cngVal}</div>;
      },
    },
  ];

  if (enblAct) {
    columns.push({
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className='action-td-coverdiv'>
          <span
            onClick={() => handleEditBunk(row)}
            title="Edit"
            role="button"
            className="update-fuelrate-btn"
          >
            <i className='bx bx-rupee'></i> update
          </span>
        </div>
      ),
    });
  }

  return columns;
};

export default getFuelRateColumns;
